module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-8.svg";